import { render, staticRenderFns } from "./dwReport.vue?vue&type=template&id=edfdeba2&scoped=true&"
import script from "./dwReport.vue?vue&type=script&lang=js&"
export * from "./dwReport.vue?vue&type=script&lang=js&"
import style0 from "./dwReport.vue?vue&type=style&index=0&id=edfdeba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfdeba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edfdeba2')) {
      api.createRecord('edfdeba2', component.options)
    } else {
      api.reload('edfdeba2', component.options)
    }
    module.hot.accept("./dwReport.vue?vue&type=template&id=edfdeba2&scoped=true&", function () {
      api.rerender('edfdeba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Report/dwReport.vue"
export default component.exports